/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectPerTypePerMonthResponse
 */
export interface ProjectPerTypePerMonthResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectPerTypePerMonthResponse
     */
    monthAndYear: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPerTypePerMonthResponse
     */
    contractType: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectPerTypePerMonthResponse
     */
    projectCounter: number;
}

/**
 * Check if a given object implements the ProjectPerTypePerMonthResponse interface.
 */
export function instanceOfProjectPerTypePerMonthResponse(value: object): value is ProjectPerTypePerMonthResponse {
    if (!('monthAndYear' in value) || value['monthAndYear'] === undefined) return false;
    if (!('contractType' in value) || value['contractType'] === undefined) return false;
    if (!('projectCounter' in value) || value['projectCounter'] === undefined) return false;
    return true;
}

export function ProjectPerTypePerMonthResponseFromJSON(json: any): ProjectPerTypePerMonthResponse {
    return ProjectPerTypePerMonthResponseFromJSONTyped(json, false);
}

export function ProjectPerTypePerMonthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPerTypePerMonthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'monthAndYear': json['monthAndYear'],
        'contractType': json['contractType'],
        'projectCounter': json['projectCounter'],
    };
}

export function ProjectPerTypePerMonthResponseToJSON(value?: ProjectPerTypePerMonthResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'monthAndYear': value['monthAndYear'],
        'contractType': value['contractType'],
        'projectCounter': value['projectCounter'],
    };
}

